import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import { MdCall, MdEmail, MdLocationPin, MdSearch, MdWhatsapp } from "react-icons/md";
import { AiFillWechat } from "react-icons/ai";
import logo from '../assets/logo.png'
import logo_icon from '../assets/logo_icon.png'

export default function DonateContent(props) {

  const appContext = useContext(AppContext);

  /* Place states here */
  const [ ready, setReady ] = useState(false);

  async function init() {
    //run initializations here
    setReady(false);
    //..
    
    setReady(true);
  }


  

  useEffect(() => {
    init();
  }, [ ])

  if(ready) {
    return (
      <div 
        className="MainBodySection"
        style={{
          paddingBottom: "50px",
          paddingTop: "50px"
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h6
                className="main-section-title"
              >
                Donate To Us
                <span
                  style={{
                    display: "block",
                    borderBottom: "3px solid var(--secondaryColor)",
                    width: "50px",
                    marginTop: "10px"
                  }}
                >

                </span>
              </h6>
            </div>

            <div className="col-md-12 bg-primary">
              <div 
                className="text-center"
                style={{
                  padding: "30px",
                }}
              >
                <img
                  src={logo_icon}
                  style={{
                    width: "100px"
                  }}
                />

                <br/>
                <img
                  src={logo}
                  style={{
                    width: "250px"
                  }}
                />
              </div>
            </div>

            <div className="col-md-12 text-center">
              
              <h6
                className="font-semi-bold mt-5 mb-5"
                style={{
                  fontSize: "24px",
                }}
              >
                Your donation is very important to us. You can donate via the following bank account
              </h6>
              
              <div className="card">
                <div className="card-body">
                  <div className="mt-2 mb-2">
                    <label className="form-label">Bank Name</label>
                    <h6
                      style={{
                        fontSize: "24px"
                      }}
                    >
                      NMB
                    </h6>
                  </div>

                  <div className="mt-2 mb-2">
                    <label className="form-label">Bank Account Name</label>
                    <h6
                      style={{
                        fontSize: "24px"
                      }}
                    >
                      TYIDI
                    </h6>
                  </div>

                  <div className="mt-2 mb-2">
                    <label className="form-label">Bank Account Number</label>
                    <h6
                      style={{
                        fontSize: "24px"
                      }}
                    >
                      000000000
                    </h6>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    )
  } else {
    return (
      <div 
        className="container mSupportLoading"
      >
        {getInlineLoader()}
      </div>
    );
  }

  
}